import styled from 'styled-components';
import { ImageUtils } from '../../utils/ImageUtils';
import { mobileQuery } from '../../utils';

export const Header = () => {
  return (
    <HeaderContainer>
      <LogoContainer>
        <Logo src={ImageUtils.Logo} />
      </LogoContainer>
      <TableContainer>
        <HeaderRow>
          <HeaderCell></HeaderCell>
          <HeaderCell>
            <HeaderTitle>온라인 새틀라이트</HeaderTitle>
          </HeaderCell>
          <HeaderCell>
            <HeaderTitle>오프라인 이벤트</HeaderTitle>
          </HeaderCell>
        </HeaderRow>
        <Table>
          <colgroup>
            <col style={{ width: '10%' }} />
            <col style={{ width: '53%' }} />
            <col style={{ width: '37%' }} />
          </colgroup>
          <tbody>
            <tr>
              <TableCell1>새틀 for 새틀</TableCell1>
              <TableCell1>
                12월 29일(월)~1월 22일(목)
                <br />
                <span>매일 오후 6시 (주말 프리롤)</span>
              </TableCell1>
              <TableCell1 rowSpan={2}>1월 24일(토)</TableCell1>
            </tr>
            <tr>
              <TableCell1>새틀라이트</TableCell1>
              <TableCell1>
                12월 29일(월)~1월 22일(목)
                <br />
                <span>매일 오후 8시, 오후 10시</span>
              </TableCell1>
            </tr>
            <tr>
              <TableCell2>장소</TableCell2>
              <TableCell2>피망 쇼다운 홀덤 앱</TableCell2>
              <TableCell2>ES Studio 수원</TableCell2>
            </tr>
          </tbody>
        </Table>
      </TableContainer>
    </HeaderContainer>
  );
};

const TableContainer = styled.div`
  position: relative;
  z-index: 1;
  max-width: 820px;
  margin: 0 auto;

  ${mobileQuery} {
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
  }
`;

const HeaderContainer = styled.header``;

const Logo = styled.img`
  position: relative;
  z-index: 1;
  width: 550px;
  ${mobileQuery} {
    width: 319px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  padding-top: 35px;
  position: relative;
  z-index: 1;

  ${mobileQuery} {
    padding-top: 22px;
    align-items: center;
    justify-content: center;
  }
`;

const Table = styled.table`
  width: 100%;
  text-align: left;
  margin-bottom: 25px;
  position: relative;

  ${mobileQuery} {
    margin-bottom: 0px;
  }
`;

const TableCell = styled.td`
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
  font-weight: 400;
  font-size: 18px;
  letter-spacing: -0.05em;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.7);
  padding: 7px 9px 9px 9px;
  box-sizing: border-box;
  min-width: 120px;
  backdrop-filter: blur(9px);

  ${mobileQuery} {
    padding: 5px 0;
    min-width: 60px;
    line-height: 1.3;
    font-size: 10px;
  }
`;

const TableCell1 = styled(TableCell)`
  color: #ccd4d6;

  strong {
    font-weight: 700;
  }

  span {
    color: #7f9397;
  }
`;

const TableCell2 = styled(TableCell)`
  color: #ccd4d6;

  ${mobileQuery} {
  }
`;

const HeaderRow = styled.div`
  display: flex;
  width: 100%;
  border-collapse: collapse;
`;

const HeaderCell = styled.div`
  background: #12525b;
  border-top: 2px solid #30848f;
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.1);
  color: rgba(255, 255, 255, 0.8);
  height: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    width: 10%; /* 첫 번째 빈 셀의 너비 조정 */
  }

  &:nth-child(2) {
    width: 53%; /* 두 번째, 세 번째 셀의 너비 */
  }

  &:nth-child(3) {
    width: 37%; /* 두 번째, 세 번째 셀의 너비 */
  }

  ${mobileQuery} {
    height: 18px;
    border-top: 1px solid #30848f;
    box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.1);
  }
`;

const HeaderTitle = styled.h3`
  margin: 0;
  padding: 0;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  font-size: 16px;

  ${mobileQuery} {
    font-size: 10px;
  }
`;
